import {
  CButton,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useState } from "react";

export default function DeleteConfirmationWithRemarks(props) {
  const { visible, onConfirm, onCancel } = props;
  const [remarks, setRemarks] = useState("");

  const handleConfirm = () => {
    // console.log("======", remarks)
    onConfirm(remarks);
    onCancel();
  }

  return (
    <CModal visible={visible} onClose={onCancel} alignment="center">
      <CModalHeader onClose={onCancel}>
        <CModalTitle>Are you sure you want to delete this item?</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <p>Remarks:</p>
        <CFormTextarea
          id="delete-remarks"
          placeholder="Enter remarks here..."
          onChange={(e) => setRemarks(e.target.value)}
          value={remarks}
       />
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onCancel}>
          Close
        </CButton>
        <CButton color="danger" onClick={handleConfirm}>
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  );
}
